/* rl-cush.js — behaviour for rl-cush-* (PDP) and rl-cush-hm-* (homepage) sections.
   Scrollers (dots / arrows / autoplay), UGC video carousel, buy-box fallback price. */
(function () {
  'use strict';

  function initScroller(root) {
    var track = root.querySelector('[data-rlc-track]');
    if (!track) return;
    var dots = root.querySelector('[data-rlc-dots]');
    var prev = root.querySelector('[data-rlc-prev]');
    var next = root.querySelector('[data-rlc-next]');
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;

    if (dots) {
      dots.innerHTML = '';
      items.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rl-cush-dot';
        b.setAttribute('aria-label', 'Fara á glæru ' + (i + 1));
        b.addEventListener('click', function () {
          track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
    }

    function update() {
      if (!dots) return;
      var sl = track.scrollLeft, idx = 0, best = Infinity;
      items.forEach(function (it, i) {
        var d = Math.abs(it.offsetLeft - track.offsetLeft - sl);
        if (d < best) { best = d; idx = i; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();

    /* Re-snap to the nearest slide after a resize so the track never rests between cards. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var sl = track.scrollLeft, idx = 0, best = Infinity;
        items.forEach(function (it, i) {
          var d = Math.abs(it.offsetLeft - track.offsetLeft - sl);
          if (d < best) { best = d; idx = i; }
        });
        track.scrollTo({ left: items[idx].offsetLeft - track.offsetLeft, behavior: 'instant' });
      }, 150);
    });

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var auto = parseInt(root.getAttribute('data-rlc-autoplay') || '0', 10);
    if (auto > 0) {
      var timer = null, paused = false;
      function tick() {
        if (paused || root.matches(':hover')) return;
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2) return;
        if (track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }
      function start() { clearInterval(timer); timer = setInterval(tick, auto); }
      track.addEventListener('pointerdown', function () { paused = true; });
      track.addEventListener('pointerup', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      track.addEventListener('touchend', function () { paused = false; }, { passive: true });
      start();
    }
  }

  function initVideos(root) {
    var videos = root.querySelectorAll('video');
    Array.prototype.forEach.call(videos, function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      var wrap = v.closest('[data-rlc-video]') || v.parentElement;
      var btn = wrap ? wrap.querySelector('[data-rlc-playpause]') : null;
      function setState() { if (btn) btn.setAttribute('data-state', v.paused ? 'paused' : 'playing'); }
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (v.paused) { v.play().catch(function () {}); } else { v.pause(); }
        wrap.setAttribute('data-user-paused', v.paused ? 'true' : 'false');
      });
      v.addEventListener('play', setState);
      v.addEventListener('pause', setState);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              if (wrap.getAttribute('data-user-paused') !== 'true') v.play().catch(function () {});
            } else { v.pause(); }
          });
        }, { threshold: 0.2 });
        io.observe(v);
      } else { v.play().catch(function () {}); }
      setState();
    });
  }

  /* Hide the fallback price in the buy box once the Kaching bundle widget renders. */
  function watchBundles() {
    var fb = document.querySelector('[data-rl-cush-fallback-price]');
    if (!fb) return;
    function check() {
      if (document.querySelector('[class*="kaching"], [id*="kaching"], kaching-bundles')) fb.hidden = true;
    }
    check();
    if ('MutationObserver' in window) {
      new MutationObserver(check).observe(document.body, { childList: true, subtree: true });
    }
    setTimeout(check, 2500);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rlc-scroller]'), function (el) {
      if (el.getAttribute('data-rlc-init')) return;
      el.setAttribute('data-rlc-init', '1');
      initScroller(el);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-rlc-videos]'), function (el) {
      if (el.getAttribute('data-rlc-vinit')) return;
      el.setAttribute('data-rlc-vinit', '1');
      initVideos(el);
    });
    watchBundles();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
